import { AlternativeRegistrationModalProvider } from '@exam-center/alternative-registration';
import { APP_PERMISSIONS } from '@exam-center/permission';
import {
  ProctoringRegistrationDetailsPageHeader,
  ProctoringRegistrationDetailsProvider,
} from '@exam-center/proctoring-registrations';
import { useParams } from '@exam-center/router';
import { PermissionGuard } from '@shared/permissions';
import { Outlet } from 'react-router-dom';

export default function ProctoringRegistrationDetailsLayout() {
  const { examCenterCode, examEventId, examEventExamineeId } = useParams(
    '/:examCenterCode/proctoring/exam-events/:examEventId/registrations/:examEventExamineeId',
  );

  return (
    <PermissionGuard requiredPermission={APP_PERMISSIONS.PROCTORING.REGISTRATION.VIEW}>
      <ProctoringRegistrationDetailsProvider
        examCenterCode={examCenterCode}
        examEventId={examEventId}
        examEventExamineeId={examEventExamineeId}
      >
        <AlternativeRegistrationModalProvider>
          <ProctoringRegistrationDetailsPageHeader />
          <Outlet />
        </AlternativeRegistrationModalProvider>
      </ProctoringRegistrationDetailsProvider>
    </PermissionGuard>
  );
}
